import { CalendarOutline } from '@lyearn/icons';
import { DatabaseFieldTypeEnum } from '@/types/schema';

export const DateFieldStaticConfig = {
  Icon: CalendarOutline,
  type: DatabaseFieldTypeEnum.Date,
  labelKey: 'Common:Filter.Date',
};
